"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var button_1 = require("@kaizen/button");
var chevron_down_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/chevron-down.icon.svg"));
var meatballs_icon_svg_1 = __importDefault(require("@kaizen/component-library/icons/meatballs.icon.svg"));
var draft_menu_1 = require("@kaizen/draft-menu");
var TitleBlockMenuItem_1 = require("./TitleBlockMenuItem");
var TitleBlockZen_1 = require("./TitleBlockZen");
var Toolbar_1 = __importDefault(require("./Toolbar"));
var MainActions_module_scss_1 = __importDefault(require("./MainActions.module.scss"));
var MainActions = function (_a) {
    var primaryAction = _a.primaryAction, defaultAction = _a.defaultAction, _b = _a.reversed, reversed = _b === void 0 ? false : _b, overflowMenuItems = _a.overflowMenuItems, _c = _a.showOverflowMenu, showOverflowMenu = _c === void 0 ? false : _c;
    var items;
    if (primaryAction && (0, TitleBlockZen_1.isMenuGroupNotButton)(primaryAction)) {
        var menuContent = primaryAction.menuItems.map(function (item, idx) { return (react_1["default"].createElement(TitleBlockMenuItem_1.TitleBlockMenuItem, __assign({}, item, { key: "main-action-primary-menu-item-".concat(idx), automationId: "main-action-primary-menu-item-".concat(idx), "data-testid": "main-action-primary-menu-item-".concat(idx) }))); });
        items = __spreadArray(__spreadArray([], (defaultAction
            ? [
                {
                    key: "defaultAction",
                    node: (react_1["default"].createElement(button_1.Button, __assign({}, __assign(__assign({}, defaultAction), { reversed: defaultAction.reversed !== undefined
                            ? defaultAction.reversed
                            : reversed }), { "data-automation-id": "title-block-default-action-button", "data-testid": "title-block-default-action-button" })))
                },
            ]
            : []), true), (primaryAction
            ? [
                {
                    key: "primaryAction",
                    node: (react_1["default"].createElement(draft_menu_1.Menu, { align: "right", button: react_1["default"].createElement(button_1.Button, { label: primaryAction.label, primary: true, reversed: reversed, icon: chevron_down_icon_svg_1["default"], iconPosition: "end", "data-automation-id": "title-block-primary-action-button", "data-testid": "title-block-primary-action-button", badge: primaryAction.badge
                                ? __assign(__assign({}, primaryAction.badge), { variant: "dark" }) : undefined }) },
                        react_1["default"].createElement(draft_menu_1.MenuList, null, menuContent)))
                },
            ]
            : []), true);
    }
    else {
        items = __spreadArray(__spreadArray([], (defaultAction
            ? [
                {
                    key: "defaultAction",
                    node: (react_1["default"].createElement(button_1.Button, __assign({}, __assign(__assign({}, defaultAction), { reversed: defaultAction.reversed !== undefined
                            ? defaultAction.reversed
                            : reversed }), { "data-automation-id": "title-block-default-action-button", "data-testid": "title-block-default-action-button" })))
                },
            ]
            : []), true), (primaryAction
            ? [
                {
                    key: "primaryAction",
                    node: (react_1["default"].createElement(button_1.Button, __assign({}, __assign(__assign({}, primaryAction), { primary: primaryAction.primary !== undefined
                            ? primaryAction.primary
                            : true, reversed: primaryAction.reversed !== undefined
                            ? primaryAction.reversed
                            : reversed }), { "data-automation-id": "title-block-primary-action-button", "data-testid": "title-block-primary-action-button", badge: primaryAction.badge
                            ? __assign(__assign({}, primaryAction.badge), { variant: "dark" }) : undefined })))
                },
            ]
            : []), true);
    }
    if (overflowMenuItems && showOverflowMenu && overflowMenuItems.length > 0) {
        items = __spreadArray([
            {
                key: "overflowMenu",
                node: (react_1["default"].createElement(draft_menu_1.Menu, { align: "right", button: react_1["default"].createElement(button_1.IconButton, { label: "Open secondary menu", reversed: reversed, icon: meatballs_icon_svg_1["default"] }) },
                    react_1["default"].createElement(draft_menu_1.MenuList, null, overflowMenuItems.map(function (menuItem, idx) { return (react_1["default"].createElement(TitleBlockMenuItem_1.TitleBlockMenuItem, __assign({}, menuItem, { key: "main-action-overflow-item-menu-item-".concat(idx) }))); }))))
            }
        ], items, true);
    }
    return (react_1["default"].createElement("div", { className: MainActions_module_scss_1["default"].mainActionsContainer },
        react_1["default"].createElement(Toolbar_1["default"], { items: items, automationId: "title-block-main-actions-toolbar", "data-testid": "title-block-main-actions-toolbar" })));
};
exports["default"] = MainActions;
//# sourceMappingURL=MainActions.js.map